class FileValidation {

    /**
     * Validate the local file to see if the file size is within
     * the maximum value of the config
     * @param  {int} filesize in bytes
     * @param {string} maxFileSize in string format, like "25mb"
     * @return {Boolean}
     */
    static validateFileSize (filesize, maxFileSize) {

        if (filesize === 0) {
            return false;
        }

        var maxbytes = 0;
        // Mb
        if (maxFileSize.indexOf('mb') > -1) {
            var mb = maxFileSize.substr(0, maxFileSize.indexOf('mb'));
            // 1024 * 1024
            maxbytes = mb * 1048576;
        }
        // Kb
        else if (maxFileSize.indexOf('kb') > -1) {
            var kb = maxFileSize.substr(0, maxFileSize.indexOf('kb'));
            maxbytes = kb * 1024;
        }
        // Byte
        else {
            maxbytes = maxFileSize;
        }

        return filesize <= maxbytes;
    };
}

module.exports = FileValidation;
